<dialog [id]="modalDialogId" class="modal">
  <div class="modal-box">
    <h3 class="text-3xl font-bold">{{ 'shared.add_data' | transloco }}</h3>
    <p class="py-4 text-neutral-500">{{ 'invoice.convenient_upload' | transloco }}</p>

    <div class="flex gap-4">
      <button *ngIf="!isUploadActive()"
        class="w-full h-[20vh] rounded-[14px] border-spacing-2 border-2 border-primary-500 border-dashed bg-primary-200 flex flex-col justify-evenly items-center select-none min-h-[250px]"
        (click)="fileInput.click()" (dragover)="fileUploadHelper.onDragOver($event)"
        (drop)="fileUploadHelper.onDrop($event)">
        <input #fileInput type="file" accept=".pdf,.xls,.xlsx" (change)="fileUploadHelper.onFileSelected($event)"
          class="hidden" multiple>

        <img src="assets/icons/upload-slim.svg" width="60px" height="60px" alt="{{ 'shared.upload_icon' | transloco }}">
        <p class="text-center text-sm text-neutral-1600"><span class="underline">{{ 'shared.click_to_upload.click' |
            transloco }}</span>{{ 'shared.click_to_upload.to_upload' | transloco }}<span class="underline">{{
            'shared.click_to_upload.drag_and_drop' | transloco }}</span></p>
      </button>

      <div *ngIf="isUploadActive()"
        class="flex flex-col w-full rounded-[16px] border-border border-[1px] p-5 max-w-ultrawide min-w-[300px] min-h-[250px]">
        <ng-container *ngFor="let uploadInfo of listOfRecentUploads; let i = index">
          <app-uploaded-file [fileSrc]="uploadInfo.fileSrc" [fileName]="uploadInfo.fileName"
            [fileSize]="uploadInfo.fileSizeMB" [currentValue]="uploadInfo.currentUploadProgress"
            (stopClick)="stopClicked(i)" [canceled]="uploadInfo.canceled"></app-uploaded-file>
        </ng-container>
      </div>
    </div>
  </div>
  <form method="dialog" class="modal-backdrop">
    <button>Close</button>
  </form>
</dialog>